module.exports = __webpack_public_path__ + "img/colore_orange.png";